import parse from 'html-react-parser';

import ApiState from '@/components/ApiState/ApiState';
import Layout from '@/components/Layout/Layout';
import Overlay from '@/components/Overlay/Overlay';
import { useBodyClass } from '@/hooks/useBodyClass';
import { useBasicPage } from '@/api/useThesaurusTerm';

import segellsColor from '@/assets/img/overlays/segells-color@2x.png';

function Credits({ page }) {
    useBodyClass('has-background-light');
    const { data, isLoading, error } = useBasicPage(page.section_id);
    const { title, body } = data?.[0] ?? {};

    return (
        <Layout>
            <div className="overlay-space is-hidden-touch">
                <Overlay
                    src={segellsColor}
                    style={{
                        top: 0,
                        left: '50%',
                        transform: 'translateX(-50%)',
                        zIndex: 8,
                        maxWidth: 486,
                    }}
                />
            </div>
            <ApiState isLoading={isLoading} error={error}>
                <div className="wrapper py-8">
                    <div className="columns is-desktop gap-6">
                        <div className="column is-two-fifths-desktop">
                            <div className="flow has-text-weight-light">
                                <h1 className="has-text-primary is-uppercase">{title}</h1>
                            </div>
                        </div>
                    </div>
                    <div className="flow--2xs mt-8">{body && <p>{parse(body)}</p>}</div>
                </div>
            </ApiState>
        </Layout>
    );
}

export default Credits;
